import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTipoRecurso = '/service/contabilidade/transparencia/convenio/'

class TipoConvenioService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoConvenio() {
        return this.conex.get(urlTipoRecurso + 'todosTipoConvenio/')
    }
}

export default TipoConvenioService
